import { getAuth } from 'firebase/auth';
import { collection, getFirestore, query, where } from 'firebase/firestore';

export function currentUserUid(): string {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error('É necessário autenticar para acessar os dados.');
  }

  return user.uid;
}

export function ownedCollection(collectionName: string) {
  return query(
    collection(getFirestore(), collectionName),
    where('ownerUid', '==', currentUserUid())
  );
}

export function withCurrentOwner<T extends object>(record: T): Omit<T, 'id' | 'ref' | 'path'> & { ownerUid: string } {
  const { id, ref: documentRef, path, ...data } = record as T & {
    id?: unknown;
    ref?: unknown;
    path?: unknown;
  };

  return { ...data, ownerUid: currentUserUid() } as Omit<T, 'id' | 'ref' | 'path'> & { ownerUid: string };
}
